import jujuy from "../pdfs/jujuy-006-planos.pdf"

const pdfs = {
    jujuyPlanos: jujuy
}

export default pdfs